<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
#nprogress {
  z-index: 9999;
  position: fixed;
  .bar {
    background: #13ce66 !important;
  }
  &::before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.1);
  }
  // &::after {
  // }
}
</style>
